import { Request } from '@mam/main/ApiClient';
import { DEFAULT_DECIMAL } from '~/UI/Input/DecimalInput';

export enum ERPGrowthRevenueError {}

export const getHumanReadableErrorCode = (codes: Set<string>): string | null => {
	return null;
};

type MessyRequestBody = { countryCode: string; yearlyVolume?: string; yoyGrowth?: string }[];
const prepareRequestBody = (
	messyBody: MessyRequestBody
): {
	yoyGrowth: string; // AS string but a decimal - diplayed as percentage, hence 4% = 0.04, 100% = 1
	yearlyVolume: string;
	countryCode: string;
}[] =>
	messyBody
		.filter(
			(value): value is { countryCode: string; yearlyVolume: string; yoyGrowth: string } =>
				typeof value.yoyGrowth !== 'undefined' && typeof value.yearlyVolume !== 'undefined'
		)
		.map(({ countryCode, yoyGrowth, yearlyVolume }) => ({
			yoyGrowth: (Number(yoyGrowth) / 100).toFixed(DEFAULT_DECIMAL + 2),
			yearlyVolume: yearlyVolume,
			countryCode,
		}));

export class ERPGrowthVolumeRequest implements Request<Record<never, never>, Record<never, never>> {
	public readonly knownErrorCodes = Object.values(ERPGrowthRevenueError);
	public readonly path: string;
	public readonly method = 'put';
	public readonly body: BodyInit | null = null;

	public constructor(userId: string, virtualPackId: string, sessionId: string, body: MessyRequestBody) {
		const requestBody = body.filter(({ yearlyVolume }) => yearlyVolume !== '');
		this.path = `users/${userId}/erp/packages/${virtualPackId}/sessions/${sessionId}/country-figures`;
		this.body = JSON.stringify(prepareRequestBody(requestBody));
	}

	decode(response: Record<never, never>) {
		return response;
	}
}
